import { TReqConfigValidated } from '@/services/JSCService';

import SHomeCommonJSC from '../../schema/SHomeCommonJSC';
import { SunnyRequestBuilder } from '../Common/SunnyRequestBuilder';
import { ISHomeCommonRequestParams } from './interfaces/ISHomeCommonRequestParams';

export default class SHomeRequestBuilder extends SunnyRequestBuilder {
  createGetBenefitBannerQuery(reqParams: ISHomeCommonRequestParams): TReqConfigValidated {
    return this.validate(SHomeCommonJSC, reqParams).map((params) => this.makeConfig('GET', '/shome/benefit', params));
  }

  createGetSpecialEventsQuery(reqParams: ISHomeCommonRequestParams): TReqConfigValidated {
    return this.validate(SHomeCommonJSC, reqParams).map((params) =>
      this.makeConfig('GET', '/shome/specialEvent', params),
    );
  }
}
